import { createAction, props } from '@ngrx/store';
import { DistrictsModel } from '@roi/common/models/province.model';

export const loadDistricts = createAction(
  '[Geo] Load Districts',
  props<{ provinceId: number }>()
);

export const loadDistrictsSuccess = createAction(
  '[Geo] Load Districts Success',
  props<{ districts: DistrictsModel[] }>()
);

export const loadDistrictsFailure = createAction(
  '[Geo] Load Districts Failure',
  props<{ error: any }>()
);
